import { Navigate } from 'react-router-dom'
import { useAccess } from '../../hooks/useAccess'
import { SessionStatus } from './SessionStatus'
import { adminGuardDecision } from '../../lib/adminGuard'
export { adminGuardDecision } from '../../lib/adminGuard'

/** Guards a route so only admin users (is_admin === true) can view it.
 *  While access is loading, renders the standard session-loading treatment.
 *  On deny or unavailable access, client-redirects to '/'.
 *  The backend requireAdmin middleware remains the actual security boundary. */
export default function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { access, loading } = useAccess()
  const decision = adminGuardDecision(access, loading)

  if (decision === 'loading') return <SessionStatus />
  if (decision === 'allow') return <>{children}</>
  return <Navigate to="/" replace />
}
